import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../features/auth/services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { ThemeService } from '../../services/theme.service';

interface FAQ {
  question: string;
  answer: string;
  isOpen: boolean;
}

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  private allowedAccounts = ['2228', '2665', '2559', '2907', '2988', '2997', '2998', '2999'];
  showFaq = false;

  faqs: FAQ[] = [
    {
      question: 'Para dudas sobre tu seguro contratado con Banamex',
      answer: '',
      isOpen: true
    },
    {
      question: 'Soporte técnico o problemas con la aplicación',
      answer: '',
      isOpen: true
    }
  ];

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private themeService: ThemeService
  ) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.checkAccountAccess();
  }

  private checkAccountAccess(): void {
    const userAccount = this.authService.getAccount();
    const uuidc = this.route.snapshot.queryParams['uuidc'];
    
    if ((userAccount && this.allowedAccounts.includes(userAccount)) || 
        (uuidc && this.allowedAccounts.includes(uuidc))) {
      this.showFaq = true;
      if (uuidc && this.allowedAccounts.includes(uuidc)) {
        localStorage.setItem('uuidClient', uuidc);
        this.themeService.loadThemeConfig(parseInt(uuidc)).subscribe({
          next: (response) => {
            if (response.theme) {
              this.themeService.applyTheme(response.theme);
            }
          },
          error: () => {}
        });
      }
    } else {
      window.location.href = 'https://sitio-pwa-asistencias.dev-pruebas.com/faqs';
    }
  }

  toggleFaq(index: number): void {
    this.faqs[index].isOpen = !this.faqs[index].isOpen;
  }


}